<div id="drop-zone" class="mx-auto form-control" (dragover)="preventDefault($event)" (drop)="handleDrop($event)">
	<input id="file-input" hidden multiple type="file" (change)="onFileChange($event)" s3Upload accept="image/*" />
	<label for="file-input" *ngIf="!preview || imageUrls?.length == 0"
		>Drag and drop files here or click to select</label
	>
	<ng-container *ngIf="preview">
		<img *ngFor="let file of imageUrls" [src]="file" />
	</ng-container>
</div>
